import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ApiResponse } from "../../../types/apiResponse";
import type { UpdateQuoteProductData } from "../types";
import { fetchUpdateQuoteProduct } from "../apis/fetchUpdateQuoteProduct";

export const useUpdateQuoteProduct = () => {
    const queryClient = useQueryClient();

    return useMutation<ApiResponse, Error, UpdateQuoteProductData>({
        mutationFn: fetchUpdateQuoteProduct,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["quotes"] });
        },
    });
};
